import {createReducer, on} from "@ngrx/store";
import {FundAiSetupActions} from "./fund-ai-setup.actions";
import {FundAiSetupState, initialFundAiSetupState} from "./fund-ai-setup.state";

export const fundAiSetupReducer = createReducer<FundAiSetupState>(
    initialFundAiSetupState,

    on(FundAiSetupActions.loadJobs, (state, {fundId}) => ({
        ...state,
        jobsByFund: {
            ...state.jobsByFund,
            [fundId]: {
                data: state.jobsByFund[fundId]?.data ?? [],
                status: "LOADING",
                errorMessage: ""
            }
        }
    })),
    on(FundAiSetupActions.loadJobsSuccess, (state, {fundId, jobs}) => ({
        ...state,
        jobsByFund: {
            ...state.jobsByFund,
            [fundId]: {data: jobs, status: "LOADED", errorMessage: ""}
        }
    })),
    on(FundAiSetupActions.loadJobsError, (state, {fundId, errorMsg}) => ({
        ...state,
        jobsByFund: {
            ...state.jobsByFund,
            [fundId]: {
                data: state.jobsByFund[fundId]?.data ?? [],
                status: "ERROR",
                errorMessage: errorMsg
            }
        }
    })),

    on(FundAiSetupActions.loadDetail, state => ({
        ...state,
        activeDetail: {data: undefined, status: "LOADING", errorMessage: ""}
    })),
    on(FundAiSetupActions.loadDetailSuccess, (state, {detail}) => ({
        ...state,
        activeDetail: {data: detail, status: "LOADED", errorMessage: ""}
    })),
    on(FundAiSetupActions.loadDetailError, (state, {errorMsg}) => ({
        ...state,
        activeDetail: {data: undefined, status: "ERROR", errorMessage: errorMsg}
    })),

    on(FundAiSetupActions.acceptResult, (state, {resultId}) => ({
        ...state,
        pendingActionResultIds: [...state.pendingActionResultIds, resultId]
    })),
    on(FundAiSetupActions.skipResult, (state, {resultId}) => ({
        ...state,
        pendingActionResultIds: [...state.pendingActionResultIds, resultId]
    })),
    on(
        FundAiSetupActions.acceptResultSuccess,
        FundAiSetupActions.skipResultSuccess,
        FundAiSetupActions.acceptResultError,
        FundAiSetupActions.skipResultError,
        (state, {resultId}) => ({
            ...state,
            pendingActionResultIds: state.pendingActionResultIds.filter(id => id !== resultId)
        })
    ),

    on(FundAiSetupActions.startError, (state, {errorMsg}) => ({...state, error: errorMsg})),
    on(FundAiSetupActions.clearError, state => ({...state, error: undefined}))
);
